<template>
  <header>
    <nav>
      <div class="profile-picture">
        <router-link to="/">
          <img v-if="userProfile" :src="userProfile.UK" :alt="userProfile.Ad" />
        </router-link>
      </div>
      <div v-if="userProfile" class="welcome">Welcome, {{ userProfile.Ad }}!</div>
      <div class="logout">
        <button class="btn" @click="logout">Logout</button>
      </div>
    </nav>
  </header>
</template>

<script>
import { LoaderPlugin } from "vue-google-login";
import Vue from "vue";

Vue.use(LoaderPlugin, {
  client_id:
    "280433113103-encb95qml98rf4gqrhbejj2eml1rojsm.apps.googleusercontent.com"
});

export default {
  name: "TheHeader",
  data() {
    return {
      userProfile: null
    };
  },
  methods: {
    logout() {
      Vue.GoogleAuth.then(auth2 => {
        auth2.signOut().then(() => {
          this.$router.push({ name: "login" });
        });
      });
    }
  },
  created() {
    Vue.GoogleAuth.then(async auth2 => {
      let currentUser = auth2.currentUser.get().getBasicProfile();
      console.log(currentUser);
      this.userProfile = currentUser;
    });
  }
};
</script>

<style scoped>
header {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #9e1b32;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  color: #fff;
  max-width: 900px;
  width: 900px;
}

.profile-picture img {
  width: 56px;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.btn {
  background: #fafafa;
  color: #9e1b32;
}

.btn:hover {
  background: #fafafa;
  color: #b80932;
}

@media only screen and (max-width: 767px) {
  nav {
    max-width: 375px;
    width: 100%;
    padding: 15px;
    font-size: 0.85rem;
  }

  .profile-picture img {
    width: 52px;
    border: 1px solid #fff;
  }
  .btn {
    padding: 5px 15px;
    font-size: 0.75rem;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  nav {
    max-width: 768px;
    width: 100%;
    padding: 15px 35px;
  }

  .profile-picture img {
    border: 1px solid #fff;
  }
}
</style>
